import * as firebase from 'firebase'
import Vue from 'vue'
import { empty, isWithdrawnCourse } from '@/lib/utils'
// My Grades modules

const state = {
  userColleges: [],
  caspaGPA : {
    overallGPA: 0,
    scienceGPA: 0,
    nonScienceGPA: 0
  },
};

const mutations = {
    // load user Colleges
    loadUserColleges(state, payload) {
      state.userColleges = payload
    },

    // Add User College
    addUserCollege (state, payload) {
      state.userColleges.unshift(payload)
    },
    // Remove User College
    removeCollege(state, payload) {
      state.userColleges.forEach(college => {
        if(college.id === payload) {
          state.userColleges.splice(state.userColleges.indexOf(college), 1)
        }
      })
    },
    // Add User Semesters
    addUserSemester (state, payload ) {
      for(var i=0; i < state.userColleges.length; i++) {

        if(state.userColleges[i].id === payload.collegeId) {
          state.userColleges[i].semesters.push(payload)
        }
      }

    },
    updateSemester(state, payload) {
      const userColleges = [...state.userColleges]
      for(var i=0; i < userColleges.length; i++) {
        if(userColleges[i].id === payload.collegeId) {

          for(var s=0; s < userColleges[i].semesters.length; s++) {
            if(userColleges[i].semesters[s].id === payload.semesterId) {
              userColleges[i].semesters[s].semester_completion_status = payload.semester_completion_status
            }
          }
        }
      }
      Vue.set(state, 'userColleges', userColleges)
    },
    // Remove User Semester
    removeSemester(state, payload) {
      for(var i=0; i < state.userColleges.length; i++) {
        if(state.userColleges[i].id === payload.collegeId) {

          for(var c=0; c < state.userColleges[i].semesters.length; c++) {
            if(state.userColleges[i].semesters[c].id === payload.semesterId) {
              var index = state.userColleges[i].semesters.indexOf(state.userColleges[i].semesters[c])
              state.userColleges[i].semesters.splice(index, 1)
            }
          }
        }
      }
    },

    // Add User Course
    addUserCourse(state, payload) {
      const userColleges = state.userColleges
      const matchingCollegeIndex = userColleges.findIndex((college) => college.id === payload.collegeId)
      const matchingCollege = state.userColleges[matchingCollegeIndex]

      if (matchingCollege && Array.isArray(matchingCollege.semesters)) {
        const semIndex = matchingCollege.semesters.findIndex(sem => sem.id == payload.semesterId)
        if (semIndex >= 0) {
          const newCourses = Array.from(state.userColleges[matchingCollegeIndex].semesters[semIndex].courses)
          newCourses.push(payload)
          // state.userColleges[matchingCollegeIndex].semesters[semIndex].courses.push(payload)
          Vue.set(state.userColleges[matchingCollegeIndex].semesters[semIndex], 'courses', newCourses)
          console.log(newCourses)
        }
      }
      return state

      for(var i=0; i < state.userColleges.length; i++) {

        for(var c=0; c < state.userColleges[i].semesters.length; c++) {
          if(state.userColleges[i].semesters[c].id === payload.semesterId && state.userColleges[i].semesters[c].semester_completion_status === 'Completed' && state.userColleges[i].college_term_system === 'Quarter') {

            // payload.course_credits = parseInt(payload.quarter_credits)

            payload.course_credits = parseInt(payload.quarter_credits) * 0.667
            state.userColleges[i].semesters[c].courses.push(payload)
          }
          else {
            if(state.userColleges[i].semesters[c].id === payload.semesterId) {
              state.userColleges[i].semesters[c].courses.push(payload)
            }
          }
        }
      }
    },
     // Add User Course
     addUserGrade(state, payload) {
       const userColleges = [...state.userColleges]
      for(var i=0; i < userColleges.length; i++) {
        if(userColleges[i].id === payload.collegeId) {
          for(var s=0; s < userColleges[i].semesters.length; s++) {
            if(userColleges[i].semesters[s].id === payload.semesterId) {
              for(var c=0; c < userColleges[i].semesters[s].courses.length; c++) {
                if(userColleges[i].semesters[s].courses[c].id === payload.id) {
                  userColleges[i].semesters[s].courses[c] = payload

              }
            }


          }
        }

      }
      }
      Vue.set(state, 'userColleges', userColleges)
    },
    removeCourse(state, payload) {
      for(var i=0; i < state.userColleges.length; i++) {
        if(state.userColleges[i].id === payload.collegeId) {

          for(var s=0; s < state.userColleges[i].semesters.length; s++) {
            if(state.userColleges[i].semesters[s].id === payload.semesterId) {

              for(var c=0; c < state.userColleges[i].semesters[s].courses.length; c++) {
                if(state.userColleges[i].semesters[s].courses[c].id === payload.courseId){
                  var index = state.userColleges[i].semesters[s].courses.indexOf(state.userColleges[i].semesters[s].courses[c])
                  state.userColleges[i].semesters[s].courses.splice(index, 1)
                }
              }

            }
          }
        }
      }
    },
    addApCourse(state, payload) {
      for(var i=0; i < state.userColleges.length; i++) {

        if(state.userColleges[i].id === payload.collegeId) {
          state.userColleges[i].apcourses.push(payload)
        }
      }
    },

    // Remove AP Course
    removeApCourse(state, payload) {
      for(var i=0; i < state.userColleges.length; i++) {
        if(state.userColleges[i].id === payload.collegeId) {

          for(var c=0; c < state.userColleges[i].apcourses.length; c++) {
            if(state.userColleges[i].apcourses[c].id === payload.courseId) {
              var index = state.userColleges[i].apcourses.indexOf(state.userColleges[i].apcourses[c])
              state.userColleges[i].apcourses.splice(index, 1)
            }
          }
        }
      }
    },
    // Add Clep Course
    addClepCourse(state, payload) {
      for(var i=0; i < state.userColleges.length; i++) {

        if(state.userColleges[i].id === payload.collegeId) {
          state.userColleges[i].clepcourses.push(payload)
        }
      }
    },
    // Remove Clep Course
    removeClepCourse(state, payload) {
      for(var i=0; i < state.userColleges.length; i++) {
        if(state.userColleges[i].id === payload.collegeId) {

          for(var c=0; c < state.userColleges[i].clepcourses.length; c++) {
            if(state.userColleges[i].clepcourses[c].id === payload.courseId) {
              var index = state.userColleges[i].clepcourses.indexOf(state.userColleges[i].clepcourses[c])
              state.userColleges[i].clepcourses.splice(index, 1)
            }
          }
        }
      }
    },
    // Logout Colleges
    setLogoutUser(state, payload = null) {
      state.userColleges = []
      state.caspaGPA = {
        overallGPA: 0,
        scienceGPA: 0,
        nonScienceGPA: 0
      }
    },
};

const actions = {
      // Set User College
      setUserCollege ({commit, getters}, payload) {
        // Sent College Data to firebase
        firebase.database().ref('/users/' + getters.user.uid + '/colleges').push(payload)

        .then((data) => {
          const key = data.key
          commit('addUserCollege', {
            ...payload,
            id: key,
            semesters: [],
            apcourses: [],
            clepcourses: [],
          })
        })
      },
      // Edit User College
      setEditUserCollege({commit, getters}, payload) {
        firebase.database().ref('/users/' + getters.user.uid + '/colleges/' + payload.collegeId).update(payload)
        .then((data) => {
          // const key = data.key
          // commit('editUserEvaluation', {
          //   ...payload,
          //   id:key
          // })
        })
      },
      // Remove User College
      setRemoveCollege({commit, getters}, payload) {
        firebase.database().ref('/users/' + getters.user.uid + '/colleges/').child(payload).remove()
        .then((data) => {
          commit('removeCollege', payload)
        })
      },


      // Set User Semester
      setUserSemester({commit, getters}, payload) {
        // Sent Semester Data to firebase
        firebase.database().ref('/users/' + getters.user.uid + '/colleges/').child(payload.collegeId + '/semesters').push(payload)
        .then((data) => {
          const key = data.key
          commit('addUserSemester', {
            ...payload,
            id:key,
            courses : []
          })
        })
      },
      // Set Edit Semester
      setEditUserSemester({commit, getters}, payload) {
        firebase.database().ref('/users/' + getters.user.uid + '/colleges/' + payload.collegeId + '/semesters/' + payload.semesterId).update(payload)
        .then((data) => {
          commit('updateSemester', payload)
        })
      },
      // Set Remove Semester
      setRemoveSemester({commit, getters}, payload) {
        firebase.database().ref('/users/' + getters.user.uid + '/colleges/' + payload.collegeId + '/semesters/').child(payload.semesterId).remove()
        .then((data) => {
          commit('removeSemester', payload)
        })
      },


      // Set User Course
      async setUserCourse({commit, getters, dispatch}, payload) {
        const data = await firebase.database().ref('/users/' + getters.user.uid + '/colleges/' + payload.collegeId + '/semesters/' + payload.semesterId + '/courses/').push(payload)
        const key = data.key
        commit('addUserCourse', {
          ...payload,
          id:key
        })
      },
      // Set User Course Grade
      setUserCourseGrade({commit, getters}, payload) {
        firebase.database().ref('/users/' + getters.user.uid + '/colleges/' + payload.collegeId + '/semesters/' + payload.semesterId + '/courses/' + payload.id).update({course_grade: payload.course_grade, pass_fail_grade : payload.pass_fail_grade, lab_grade : payload.lab_grade})
        .then((data) => {
          commit('addUserGrade', payload)
        })
      },
      // Edit User Course
      setEditCourse({commit, getters}, payload) {
        firebase.database().ref('/users/' + getters.user.uid + '/colleges/' + payload.collegeId + '/semesters/' + payload.semesterId + '/courses').child(payload.courseId).update(payload)
        .then((data) => {
        })
      },
      // Set Remove Course
      setRemoveCourse({commit, getters}, payload) {
        firebase.database().ref('/users/' + getters.user.uid + '/colleges/' + payload.collegeId + '/semesters/' + payload.semesterId + '/courses/').child(payload.courseId).remove()
        .then((data) => {
          commit('removeCourse', payload)
        })
      },
      // Set AP Course
      setApCourse({commit, getters}, payload) {
        firebase.database().ref('/users/' + getters.user.uid + '/colleges/' + payload.collegeId + '/apcourses/').push(payload)
        .then((data) => {
          const key = data.key
          commit('addApCourse', {
            ...payload,
            id:key
          })
        })
      },
      // Remove Ap Course
      setRemoveApCourse({commit, getters}, payload) {
        firebase.database().ref('/users/' + getters.user.uid + '/colleges/' + payload.collegeId + '/apcourses/').child(payload.courseId).remove()
        .then((data) => {
          commit('removeApCourse', payload)
        })
      },
      // Set Clep Course
      setClepCourse({commit, getters}, payload) {
        firebase.database().ref('/users/' + getters.user.uid + '/colleges/' + payload.collegeId + '/clepcourses/').push(payload)
        .then((data) => {
          const key = data.key
          commit('addClepCourse', {
            ...payload,
            id:key
          })
        })
      },
      // Remove Clep Course
      setRemoveClepCourse({commit, getters}, payload) {
        firebase.database().ref('/users/' + getters.user.uid + '/colleges/' + payload.collegeId + '/clepcourses/').child(payload.courseId).remove()
        .then((data) => {
          commit('removeClepCourse', payload)
        })
      },
};

const CASPA_GRADE_SCORE_MAP = {
  'A+': 4,
  'A': 4,
  'A-': 4,
  'B+': 3,
  'B-': 3,
  'B': 3,
  'C+': 2,
  'C-': 2,
  'C': 2,
  'D+': 1,
  'D-': 1,
  'D': 1,
  'F': 0
}

const GPA_SCORE_MAP = {
  'A+': 4,
  'A': 4,
  'A-': 3.7,
  'AB': 3.5,
  'B+': 3.3,
  'B': 3,
  'BC': 2.5,
  'B-': 2.7,
  'C+': 2.3,
  'C': 2,
  'C-': 1.7,
  'CD': 1.5,
  'D+': 1.3,
  'D': 1,
  'D-': 0.7,
  'F': 0
}

export function calculateQuaterCredits (userColleges) {
  return userColleges.map((userCollege) => {
    if (userCollege.college_term_system == 'Quarter') {
      userCollege.semesters.forEach((semester) => {
        semester.courses.forEach((course) => {
          const credits = parseFloat(course.quarter_credits)
          if (isNaN(credits)) return credits
          course.course_credits = credits * 0.667
          if (course.course_lab == 'true' && !empty(course['lab_credits'])) {
            course.lab_credits = Number(course['lab_quarter_credits']) * 0.667
          }
        })
      })
      return userCollege
    }
    return userCollege
  })
}

export function calculateCourseScore (course, gpa = false) {
  const credits = parseFloat(course.course_credits)
  if (isNaN(credits)) return 0
  const grade = course.course_grade
  const score = gpa ? GPA_SCORE_MAP[grade] : GPA_SCORE_MAP[grade]
  if (!score) return 0
  return credits * score
}

export function totalCASPAGPA (qualityPoints = [], totalCredits = []) {
  if( totalCredits.length <= 0 ) return 0
  const overallGPA = ((qualityPoints.reduce((sum, credits) => sum + credits, 0))) / ((totalCredits.reduce((sum, credits) => sum + credits, 0)))
  if (isNaN(overallGPA)) return 0
  return overallGPA
}

export function totalGPA (qualityPoints = [], totalCredits = []) {
  if( totalCredits.length <= 0 ) return 0
  const totalC = totalCredits.reduce((sum, val) => sum + val, 0)
  const grades = qualityPoints.reduce((sum, val) => sum + val, 0)
  return (grades) / totalC
}

export function removeRepeatedCoursesForGPA (courses, gpa = false) {
  if (!gpa) return courses
  const takesCourse = {}
  courses.forEach((course) => {
    if (takesCourse[course.course_id]) {
      const lastScore = calculateCourseScore(takesCourse[course.course_id], true)
      const newScore = calculateCourseScore(course, true)
      if (lastScore >= newScore) {
        return null
      }
    }
    takesCourse[course.course_id] = course
  })
  return Object.values(takesCourse)
}

export function calculateCoursesCreditsTotal (courses, gpa, courseFilter = (c) => c, tc = [], qp = [], coursesTaken = {}) {
  const totalCredits = tc
  const qualityPoints = qp
  const takenCourses = coursesTaken

  removeRepeatedCoursesForGPA(courses, gpa).forEach((course) => {
    if (isWithdrawnCourse(course)) return null
    if (courseFilter(course)) {
      const courseCredits = parseFloat(course.course_credits)
      const totalCredit = isNaN(courseCredits) ? 0 : courseCredits
      const quantityPoint = calculateCourseScore(course, gpa)

      if (gpa) {
        if (takenCourses[course.course_id] && takenCourses[course.course_id]['quantityPoint'] > quantityPoint) return false
        takenCourses[course.course_id] = {
          totalCredit,
          quantityPoint
        }
      }
      totalCredits.push(totalCredit)
      qualityPoints.push(quantityPoint)

      if (course.course_lab == 'true' && !empty(course['lab_credits'])) {
        const credits = Number(course['lab_credits'])
        const payload = {
          course_credits: course['lab_credits'],
          course_grade:  course['lab_grade']
        }
        totalCredits.push(isNaN(credits) ? 0 : credits)
        qualityPoints.push(calculateCourseScore(payload, gpa))
      }
    }
  })
  return {
    totalCredits,
    qualityPoints
   }
}

export function calculateTotalCreditPoints (userColleges, gpa = false, courseFilter = (c) => c) {
  let totalCredits = []
  let qualityPoints = []
  let takenCourses = {}
  const semesters = calculateQuaterCredits(userColleges).map(({ semesters }) => semesters.filter(({ semester_completion_status }) => semester_completion_status == 'Completed')).flat()
  const allCourses = semesters.map(({ courses }) => courses).flat().filter(c => empty(c.pass_fail_course) || !c.pass_fail_course ).filter(elem => elem.course_grade)
  console.log('semesters--->',allCourses)
  console.log('semesters--->',allCourses.filter(elem => elem.course_grade))

  const results = calculateCoursesCreditsTotal(allCourses, gpa, courseFilter, totalCredits, qualityPoints, takenCourses)
    totalCredits = results.totalCredits
    qualityPoints = results.qualityPoints
    takenCourses = results.takenCourses

  return {
    totalCredits,
    qualityPoints
  }
}

const getters = {
    // Get Indiviual User College Detail
    loadedCollege(state) {
      return (id) => {
        return state.userColleges.find((college) => {
          return college.id === id
        })
      }
    },
    loadedSemester(state) {
      return (collegeId, semesterId) => {
         return state.userColleges.find((college) => {
          if(college.id === collegeId) {
            return college.semesters.find((semester) => {
              return semester.id === semesterId
            })
          }
        })
      }
    },
     // User Colleges
     userColleges(state) {
      return state.userColleges
    },
     // CASPA gpa
     caspaGPA(state) {
      return state.caspaGPA
     },
     // Calculate Overall CASPA GPA
     overallCaspaGpa(state) {
      const userColleges = [...state.userColleges]
      const {  totalCredits, qualityPoints } = calculateTotalCreditPoints(userColleges)
      console.log('userColleges',userColleges)
      return totalCASPAGPA(qualityPoints, totalCredits)
     },
     // Calculate Science CASPA GPA
     scienceCaspaGpa(state) {
      const userColleges = [...state.userColleges]
      const {  totalCredits, qualityPoints } = calculateTotalCreditPoints(userColleges, false, (course) => course.course_gpa_calculation === 'Science')
      return totalCASPAGPA(qualityPoints, totalCredits)
     },
     // Calculate Nonscience CASPA GPA
    nonscienceCaspaGpa(state) {
      const userColleges = [...state.userColleges]
      const {  totalCredits, qualityPoints } = calculateTotalCreditPoints(userColleges, false, (course) => course.course_gpa_calculation === 'nonScience')
      return totalCASPAGPA(qualityPoints, totalCredits)
    },

    // Calculate Overall GPA
    overallGpa(state) {
      const userColleges = [...state.userColleges]
      const {  totalCredits, qualityPoints } = calculateTotalCreditPoints(userColleges, true)
      return totalGPA(qualityPoints, totalCredits)
     },
     // Calculate Science GPA
     scienceGpa(state) {
      const userColleges = [...state.userColleges]
      const {  totalCredits, qualityPoints } = calculateTotalCreditPoints(userColleges, true, (course) => course.course_gpa_calculation === 'Science')
      return totalGPA(qualityPoints, totalCredits)
     },
     // Calculate Nonscience GPA
    nonscienceGpa(state) {
      const userColleges = [...state.userColleges]
      const {  totalCredits, qualityPoints } = calculateTotalCreditPoints(userColleges, true, (course) => course.course_gpa_calculation === 'nonScience')
      return totalGPA(qualityPoints, totalCredits)
    },
  };

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/mygrades.js